module.exports = __webpack_public_path__ + "img/Lightning.5a2503c0.png";